import React from 'react';
import { View, Text, Pressable } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import { DateTime } from 'luxon';
import Unicon from '@/components/General/Unicon';
import usePlatform from '@/utils/hooks/usePlatform';

function CheckinKiosk({ eventInstance, onCreatePersonPress, onBarcodePress, onExitPress, loggedInUser, checkinLocation }) {
    const { isLandscape } = usePlatform();

    return (
        <View style={styles.kioskHeader}>
            <View style={styles.kioskHeaderContent}>
                <View>
                    <Text style={styles.kioskTitle}>{eventInstance?.Event?.name || "Event"} Check In</Text>
                    <View style={styles.kioskSubtitleRow}>
                        {eventInstance?.startTime && (
                            <Text style={styles.kioskSubtitle}>
                                {DateTime.fromISO(eventInstance.startTime).toLocaleString(DateTime.DATETIME_MED)}
                            </Text>
                        )}
                        {checkinLocation?.name && (
                            <View style={styles.locationTag}>
                                <Unicon name="location-outline" size={13} colorVariant="primary" />
                                <Text style={styles.locationTagText}>{checkinLocation.name}</Text>
                            </View>
                        )}
                    </View>
                </View>
                <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
                    {(isLandscape && loggedInUser?.canAny?.(["Create People"])) &&
                        <Pressable onPress={onCreatePersonPress} style={styles.kioskExitButton}>
                            <Unicon name="person-add" size={16} colorVariant="textSecondary" />
                            <Text style={styles.kioskExitText}>Create Person</Text>
                        </Pressable>
                    }
                    {(isLandscape && loggedInUser?.canAny?.(["Edit People"])) &&
                        <Pressable onPress={onBarcodePress} style={styles.kioskExitButton}>
                            <Unicon name="barcode" size={16} colorVariant="textSecondary" />
                            <Text style={styles.kioskExitText}>Add a Barcode</Text>
                        </Pressable>
                    }
                    <Pressable onPress={onExitPress} style={styles.kioskExitButton}>
                        <Unicon name="lock-open" size={18} colorVariant="textSecondary" />
                        <Text style={styles.kioskExitText}>Exit Kiosk</Text>
                    </Pressable>
                </View>
            </View>
        </View>
    );
}

export default React.memo(CheckinKiosk);

const styles = StyleSheet.create(({ colors, fonts }) => ({
    kioskHeader: {
        backgroundColor: colors.surface,
        paddingVertical: 16,
        paddingHorizontal: 20,
        borderBottomWidth: 1,
        borderBottomColor: colors.border,
    },
    kioskHeaderContent: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        alignSelf: "center",
    },
    kioskTitle: {
        fontSize: 20,
        fontFamily: fonts.heading,
        color: colors.text,
    },
    kioskSubtitleRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
        marginTop: 2,
    },
    kioskSubtitle: {
        fontSize: 14,
        fontFamily: fonts.body,
        color: colors.textSecondary,
    },
    locationTag: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        backgroundColor: colors.primaryContainer,
        paddingVertical: 2,
        paddingHorizontal: 8,
        borderRadius: 6,
    },
    locationTagText: {
        fontSize: 12,
        fontFamily: fonts.heading,
        color: colors.primary,
    },
    kioskExitButton: {
        flexDirection: "row",
        alignItems: "center",
        gap: 6,
        paddingVertical: 8,
        paddingHorizontal: 12,
        borderRadius: 8,
        backgroundColor: colors.background,
        _web: { cursor: "pointer", _hover: { opacity: 0.8 } },
    },
    kioskExitText: {
        fontSize: 14,
        fontFamily: fonts.heading,
        color: colors.textSecondary,
    },
}));
